import Vue from 'vue'
import Vuex from 'vuex'

import account from './modules/account'
import actions from './action'
import mutations from './mutations'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    account,
  },
  mutations: mutations,
  actions: actions
});
export default store



// WEBPACK FOOTER //
// ./src/store/store.js